import axios from 'axios';
import { GET_CLIENTS, GET_SPECIFIC_CLIENT, ADD_CLIENT, EDIT_CLIENT, DELETE_CLIENT, CLEAR_CLIENTS, CLIENTS_LOADING, ADD_TABLE_CLIENT, DELETE_TABLE_CLIENT, CLEAR_TABLE_CLIENTS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IClient, ITableClientLine } from '../../types/interfaces';
import store from '../store';

export const getClients = (fullList: boolean, searchBy: string, text: string) => (dispatch: Function, getState: Function) => {
  // dispatch(setClientsLoading());
  dispatch({
    type: CLIENTS_LOADING
  });
  axios
    .get('/api/clients', {...tokenConfig(getState), params: {fullList, searchBy, text}})
    .then(res =>
      dispatch({
        type: GET_CLIENTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getClientById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: CLIENTS_LOADING
  });
  axios
    .get('/api/clients/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_CLIENT,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const searchClients = async (text: string) : Promise<ITableClientLine[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/clients/search', {...tokenConfig(store.getState), params: {text}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err searchClients", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const checkCINUniqueness = async (CIN: string, ignoreId: number = -1) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/clients/checkCINUniqueness', {...tokenConfig(store.getState), params: {CIN, ignoreId}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const checkPassportUniqueness = async (passport: string, ignoreId: number = -1) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/clients/checkPassportUniqueness', {...tokenConfig(store.getState), params: {passport, ignoreId}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const getFtpScan = async (file_name: string, isCIN: number) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/clients/ftpScan', {...tokenConfig(store.getState), params: {file_name, isCIN}})
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const addClient = (client: IClient, representedBys: any[] | null, upload: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/clients', {client, representedBys, upload}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ADD_CLIENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editClient = (client: IClient, upload: any, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/clients/edit', {client, upload}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_CLIENT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteClient = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/clients/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_CLIENT,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearClients = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_CLIENTS
  })
};

export const addTableClient = (client: IClient) => (
  dispatch: Function
) => {
  dispatch({
    type: ADD_TABLE_CLIENT,
    payload: client
  });
};

export const deleteTableClient = (id: number) => (
  dispatch: Function
) => {
  dispatch({
    type: DELETE_TABLE_CLIENT,
    payload: id
  })
};

export const clearTableClients = () => (
  dispatch: Function
) => {
  dispatch({
    type: CLEAR_TABLE_CLIENTS
  })
};